var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "core-footer bg-secondary py-6",
      attrs: { "data-qa": "footer" },
    },
    [
      _c("div", { staticClass: "container core-footer__inner" }, [
        _c("div", { staticClass: "d-flex flex-column ga-6" }, [
          _c(
            "a",
            {
              attrs: { href: _setup.reverseFull({ name: "prodoctorov_main" }) },
            },
            [
              _c("img", {
                staticClass: "image-mono",
                attrs: {
                  src: _setup.isRussia
                    ? `${_setup.staticPath}_v1/pd/logos/ui-kit/prodoctorov-logo.svg`
                    : `${_setup.mediaPath}${_setup.context.request.country.site_logo}`,
                  alt: _setup.t("Логотип ПроДокторов"),
                  loading: "lazy",
                  height: "28",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap justify-space-between",
              attrs: { "data-qa": "footer_menu" },
            },
            _vm._l(_setup.footerLinks, function (data, i) {
              return _c(
                "div",
                { key: `footer-col-${i}`, staticClass: "core-footer__column" },
                _vm._l(data, function ({ title, items, hasInCISGroup }, j) {
                  return _c("div", { key: title }, [
                    _setup.isRussia || (!_setup.isRussia && hasInCISGroup)
                      ? _c(
                          "div",
                          { class: { "mt-5": j > 0 } },
                          [
                            title
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-subtitle-1 text--text mb-4",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(title) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(items, function (item) {
                              return _c(
                                "div",
                                { key: item.name },
                                [
                                  (_setup.isRussia && item.hasInPD) ||
                                  (!_setup.isRussia && item.hasInCIS)
                                    ? [
                                        item.isPRG
                                          ? _c(
                                              _setup.CorePRG,
                                              {
                                                staticClass:
                                                  "text-body-1 link-decoration-none text-secondary--text mb-4",
                                                attrs: {
                                                  target: "_self",
                                                  "data-qa": "footer_href",
                                                  url: item.href,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(item.name) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "a",
                                              {
                                                key: item.name,
                                                staticClass:
                                                  "d-table text-body-1 link-decoration-none text-secondary--text mb-4 text-left",
                                                attrs: {
                                                  href: item.href,
                                                  "data-qa": "footer_href",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                            _vm._v(" "),
                            _setup.isRussia &&
                            _setup.footerLinks.length - 1 === i
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex ga-4" },
                                  [
                                    _c(
                                      _setup.CorePRG,
                                      {
                                        attrs: {
                                          target: "_blank",
                                          url: `${_setup.staticPath}_v1/pd/documents/pdf/Единый_реестр_российских_программ.pdf`,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: `${_setup.staticPath}_v1/pd/logos/ru-reestr-programs.png`,
                                            loading: "lazy",
                                            alt: _setup.t(
                                              "Единый реестр российских программ"
                                            ),
                                            width: "45",
                                            height: "54",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      attrs: {
                                        src: `${_setup.staticPath}_v1/pd/icons/plus-18-info-color.svg`,
                                        alt: "18+",
                                        width: "38",
                                        height: "38",
                                        loading: "lazy",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ])
                }),
                0
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column ga-2",
              attrs: { "data-qa": "footer_info" },
            },
            [
              _c("div", { staticClass: "text-body-2 text-info--text" }, [
                _vm._v(
                  "\n          " + _vm._s(_setup.companyInfoText) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _setup.isRussia
                ? _c("div", { staticClass: "text-body-2 text-info--text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.roskomnadzorRegistrationText)
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.roskomnadzorDetailsText) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2 text-info--text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_setup.medicalDisclaimerText) +
                    "\n        "
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }